import { render, staticRenderFns } from "./ObserveTaskList.vue?vue&type=template&id=af33c11a&"
import script from "./ObserveTaskList.vue?vue&type=script&lang=js&"
export * from "./ObserveTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports